import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';
import '../styles/navBar.css';
import logo from '../img/KTI_logo.png';

class Navbar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hidden: true,
      newScreen: false,
    };
  }

  componentWillReceiveProps(nextProps) {
    this.setState({ newScreen: true });
  }

  mobileMenu() {
    return (
      <div
        className={this.state.hidden ? 'mobileMenu hidden' : 'mobileMenu'}
        onClick={this.closeMenuLink.bind(this)}
        onBlur={this.closeMenuLink.bind(this)}
      >
        <NavLink
          to="/portfolio"
          activeStyle={{ color: '#2A799D', fontWeight: '700' }}
        >
          Portfolio
        </NavLink>
        <NavLink
          to="/about"
          activeStyle={{ color: '#2A799D', fontWeight: '700' }}
        >
          About
        </NavLink>
        <NavLink
          to="/press"
          activeStyle={{ color: '#2A799D', fontWeight: '700' }}
        >
          Press
        </NavLink>
        <NavLink
          to="/sayhello"
          activeStyle={{ color: '#2A799D', fontWeight: '700' }}
        >
          Say Hello
        </NavLink>
      </div>
    );
  }

  renderNavBar() {
    return (
      <div className="navBar">
        <NavLink
          to="/portfolio"
          className="mainLink"
          activeStyle={{ color: '#2A799D', fontWeight: '700' }}
        >
          Portfolio
        </NavLink>
        <NavLink
          to="/about"
          className="mainLink"
          activeStyle={{ color: '#2A799D', fontWeight: '700' }}
        >
          About
        </NavLink>
        <NavLink to="/">
          <img src={logo} alt="KittyTuttleInteriors" className="logo" />
        </NavLink>
        <NavLink
          to="/press"
          className="mainLink"
          activeStyle={{ color: '#2A799D', fontWeight: '700' }}
        >
          Press
        </NavLink>
        <NavLink
          to="/sayhello"
          className="mainLink"
          activeStyle={{ color: '#2A799D', fontWeight: '700' }}
        >
          Say Hello
        </NavLink>
        <button
          alt="Menu"
          name="Menu"
          value=""
          className="burger"
          aria-label="Menu"
          onClick={this.openMenu.bind(this)}
        >
          <div className="l1" />
          <div className="l2" />
          <div className="l3" />
        </button>
      </div>
    );
  }

  openMenu() {
    this.setState({ hidden: !this.state.hidden });
  }

  closeMenuLink() {
    this.setState({ hidden: true });
  }

  render() {
    return (
      <div className="navWrapper">
        <div className="navContainer" onBlur={this.closeMenuLink.bind(this)}>
          {this.renderNavBar()}
        </div>
        {this.mobileMenu()}
      </div>
    );
  }
}

export default Navbar;



// WEBPACK FOOTER //
// ./src/containers/navBar.js